export default (url) => {
  const REGEX = /(?:\.([^.]+))?$/;
  const matches = REGEX.exec(url);

  let extensionType;
  if (matches) {
    extensionType = matches[1] && matches[1].split('?')[0];
  }

  // according to extenstion type generates dataURL and converts dataURL to blob
  switch (extensionType) {
    case 'jpg':
    case 'jpeg':
      return `image/jpeg`;
    case 'png':
      return `image/png`;
    default:
      return null;
  }
};
